"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("../../../common/utils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var StoreMapper = exports.default = /*#__PURE__*/function () {
  function StoreMapper() {
    _classCallCheck(this, StoreMapper);
  }
  return _createClass(StoreMapper, [{
    key: "mapToStore",
    value:
    /**
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
    function mapToStore(data) {
      return (0, _utils.omitNil)({
        locale: this.mapToLocale(data),
        store_identity: this.mapToIdentity(data),
        urls: this.mapToUrls(data)
      });
    }

    /**
     * @private
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
  }, {
    key: "mapToLocale",
    value: function mapToLocale(data) {
      var _data$store = data.store,
        store = _data$store === void 0 ? {} : _data$store;
      return (0, _utils.omitNil)({
        country_code: store.countryCode,
        currency_code: store.currencyCode,
        language_code: store.storeLanguage
      });
    }

    /**
     * @private
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
  }, {
    key: "mapToIdentity",
    value: function mapToIdentity(data) {
      var _data$store2 = data.store,
        store = _data$store2 === void 0 ? {} : _data$store2;
      return (0, _utils.omitNil)({
        id: store.storeId ? (0, _utils.toNumber)(store.storeId) : null,
        name: store.storeName
      });
    }

    /**
     * @private
     * @param {PaymentRequestData} data
     * @returns {Object}
     */
  }, {
    key: "mapToUrls",
    value: function mapToUrls(data) {
      var _data$store3 = data.store,
        store = _data$store3 === void 0 ? {} : _data$store3;
      return (0, _utils.omitNil)({
        cart: store.cartLink,
        checkout: store.checkoutLink,
        confirmation: store.orderConfirmationLink,
        home: store.shopPath
      });
    }
  }], [{
    key: "create",
    value:
    /**
     * @returns {StoreMapper}
     */
    function create() {
      return new StoreMapper();
    }
  }]);
}();
//# sourceMappingURL=store-mapper.js.map